
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"nonzero","fill":"none"}},[_c('path',{attrs:{"fill":"#FFD250","d":"M24 12c0 6.629-5.373 12-12 12S0 18.629 0 12C0 5.375 5.373 0 12 0s12 5.375 12 12z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M12 14.42a2.225 2.225 0 100 4.451 2.226 2.226 0 100-4.452zM9.887 6.419l.359 6.58c.017.308.271.55.58.55h2.348a.581.581 0 00.58-.55l.36-6.58a.582.582 0 00-.58-.613h-3.067a.58.58 0 00-.58.613z"}})])])
          )
        }
      }
    